export default __webpack_public_path__ + "static/media/rocket.782e5ed6.png";